export default __webpack_public_path__ + "static/support-20d6629bfb92202909d189317ef49762.png";